import React, { useEffect, useState } from 'react'
import { getRightMenuSubAPI } from '../../../services/right-menu'
import imgEmployee from '../../../images/EmployeeBtn.svg'
import imgEmployee2 from '../../../images/EmployeeBtn-disable.svg'
import { Image } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { FcNext } from 'react-icons/fc'

function SubmenuRight({
  openSubMenu3,
  openCard4,
  setOpenCard4,
  roleId,
  menuId
}) {
  const [subMenu, setSubMenu] = useState([])
  const dispatch = useDispatch()
  useEffect(() => {
    const getRightMenuSub = async () => {
      const param = { roleId, menuId }
      const res = await getRightMenuSubAPI(param)
      if (!res) return
      if (res.status) {
        setSubMenu(res.result)
      }
    }
    setClickedIndex4(null)
    getRightMenuSub()
  }, [menuId])

  const [clickedIndex4, setClickedIndex4] = useState(null)

  const handleClickSubMenu = (sub, i) => {
    setClickedIndex4(i)
    setOpenCard4(i === clickedIndex4 ? !openCard4 : true)
    dispatch({ type: 'SET_SUBMENU_ID', payload: sub.menu_sub_id })
  }

  return (
    <span className="col-2">
      {openSubMenu3 ? (
        <span className="">
          {subMenu.map((sub, i) => (
            <div
              className={`pt-2 pb-2 button-box pointer-event ${
                clickedIndex4 === i ? 'clicked' : ''
              }`}
              key={i}
              onClick={() => handleClickSubMenu(sub, i)}
            >
              <span className="d-flex gap-2 justify-content-between me-2">
                <span className="m-4 mt-0 mb-0 me-0">
                  {sub.checked ? (
                    <Image src={imgEmployee} />
                  ) : (
                    <Image src={imgEmployee2} />
                  )}
                  <span className="mb-0 me-0 m-2">{sub.menu_sub_name}</span>
                </span>
                <span>{sub.next ? <FcNext /> : <></>}</span>
              </span>
            </div>
          ))}
        </span>
      ) : (
        <></>
      )}
    </span>
  )
}

export default SubmenuRight
